import { AfterViewInit, Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[fullHeight]'
})
export class FullHeightDirective implements AfterViewInit {

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {
    }

    ngAfterViewInit(): void {
        const allElements = this.elementRef.nativeElement.parentNode.children;
        const elementsArray = Array.prototype.slice.call(allElements);
        if (elementsArray.length > 1) {
            let height = 0;
            elementsArray.forEach((element) => {
                if(!element.isSameNode(this.elementRef.nativeElement)) {
                    height += element.getBoundingClientRect().height;
                }
            })
            height += 3;
            this.renderer.setStyle(this.elementRef.nativeElement, 'height', 'calc(100% - ' + height + 'px)');
        } else {
            this.renderer.setStyle(this.elementRef.nativeElement, 'height', '100%');
        }
        this.renderer.addClass(this.elementRef.nativeElement, 'max-height-directive');
    }
}
